import FeedbackPage from '@/components/FeedbackPage'
import { getGoalFeedback } from '@/utils/feedbackContent'

export default function GoalFeedbackPage() {
  return <FeedbackPage {...getGoalFeedback()} />
}
